export const CommonRule = {
  //必填
  Require: {
    required: true,
    message: 't_required',
  },
  //邮箱
  Email: {
    match: /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{1,4})$/,
    message: 't_ruleEmail', //"邮箱地址格式错误!",
  },
  //手机号
  Mobile: {
    match: /^1[35789]\d{9}$/,
    message: 't_ruleMobile', //"手机号格式错误!",
  },
  //身份证
  Id: {
    match:
      /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
    message: 't_ruleId', //"身份证格式错误!",
  },
  //url
  Url: {
    match:
      /^((https?|ftp|file):\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/,
    message: 't_ruleUrl', //
  },
  //ip地址
  Ipv4: {
    match:
      /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/,
    message: 't_ruleIpv4', //
  },
  //日期
  Date: {
    match: /^\d{4}(\-)\d{1,2}\1\d{1,2}$/,
    message: 't_ruleDate', //
  },
  //日期时间
  DateTime: {
    match:
      /^(\d{1,4})(-|\/)(\d{1,2})\2(\d{1,2}) (\d{1,2}):(\d{1,2}):(\d{1,2})$/,
    message: 't_ruleDateTime', //
  },
  //整数
  Int: {
    match: /^[-+]?\d*$/,
    message: 't_ruleInt', //
  },
  //小数
  Float: {
    match: /^[-\+]?\d+(\.\d+)?$/,
    message: 't_ruleFloat', //
  },
  //邮政编号
  PostalNo: { match: /^\d{6}$/, message: 't_rulePostalNo' },
  //QQ号
  QQ: { match: /^[1-9][0-9]{4,10}$/, message: 't_ruleQQ' },
  //微信号
  Wechat: {
    match: /^[a-zA-Z]([-_a-zA-Z0-9]{5,19})+$/,
    message: 't_ruleWechat', //
  },
  //车牌号
  CarNo: {
    match:
      /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4}[A-Z0-9挂学警港澳]{1}$/,
    message: 't_ruleCarNo', //
  },
  //只含字母的字符串
  Letter: { match: /^[a-zA-Z]+$/, message: 't_ruleLetter' },
  //包含中文的字符串
  CN: { match: /[\u4E00-\u9FA5]/, message: 't_ruleCN' },
  //密码强度校验：密码中必须包含大小写字母、数字、特称字符，至少6个字符，最多30个字符
  Password: {
    match: /^[A-Za-z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]{6,30}$/,
    message: 't_rulePassword', //
  },
}
